import axios from 'axios';
import { API_URL } from '../config';
// const API_URL = process.env.REACT_APP_API_URL + "/auth/" || "/api/auth/";

class AuthService {
  login(username, password) {
    return axios
      .post(API_URL + "/auth/token/", {
        username,
        password
      })
      .then(response => {
        if (response.data.access) {
          localStorage.setItem("user", JSON.stringify(response.data));
          return response.data;
        }
        return response.data;
      })
      .catch(error => {
        if (error.response && error.response.status === 403) {
          // This is the "no role" error
          throw error.response.data.detail;
        }
        throw error;
      });
  }

  logout() {
    localStorage.removeItem("user");
  }

  register(username, email, password, firstName, lastName, phone) {
    return axios.post(API_URL + "/auth/register/", {
      username,
      email,
      password,
      password2: password,
      first_name: firstName,
      last_name: lastName,
      phone
    });
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem('user'));
  }

  getAccessToken() {
    const user = this.getCurrentUser();
    return user ? user.access : null;
  }

  refreshToken() {
    const user = this.getCurrentUser();
    if (!user || !user.refresh) return Promise.reject("No refresh token available");
    
    return axios
      .post(API_URL + "/auth/token/refresh/", {
        refresh: user.refresh
      })
      .then(response => {
        if (response.data.access) {
          localStorage.setItem("auth/user", JSON.stringify({
            ...user,
            access: response.data.access
          }));
        }
        return response.data;
      });
  }

  getUserDetails() {
    return axios.get(`${API_URL}/auth/me/`, {
      headers: {
        'Authorization': `Bearer ${this.getAccessToken()}`
      }
    }).then(response => response.data);
  }

  updateProfile(data) {
    return axios.patch(`${API_URL}/auth/me/`, data, {
      headers: {
        'Authorization': `Bearer ${this.getAccessToken()}`
      }
    }).then(response => response.data);
  }

  changePassword(data) {
    return axios.put(`${API_URL}/auth/change-password/`, data, {
      headers: {
        'Authorization': `Bearer ${this.getAccessToken()}`
      }
    }).then(response => response.data);
  }
}

const authServiceInstance = new AuthService();
export default authServiceInstance;